export const setWeeklySubscriptionPaused = `
  mutation SetWeeklySubscriptionPaused($id: String!, $paused: Boolean!) {
    setWeeklySubscriptionPaused(id: $id, paused: $paused) {
      id
      paused
    }
  }
`;

export const deleteWeeklySubscription = `
  mutation DeleteWeeklySubscription($id: String!) {
    deleteWeeklySubscription(id: $id)
  }
`;
